import { ArrowRight, Clock3, History, RotateCcw, X } from 'lucide-react'
import { formatDate, processPhases } from '../lib/project'
import type { ProjectRow, ProjectVersionRow } from '../types'

type Props = {
  project: ProjectRow
  versions: ProjectVersionRow[]
  busy: boolean
  onClose: () => void
  onRestore: (version: ProjectVersionRow) => void
}

export function ProjectHistoryDrawer({ project, versions, busy, onClose, onRestore }: Props) {
  return <div className="drawer-backdrop" role="presentation" onMouseDown={onClose}>
    <aside className="history-drawer" role="dialog" aria-modal="true" aria-labelledby="history-title" onMouseDown={(event) => event.stopPropagation()}>
      <header><div><span className="eyebrow">HISTORIQUE COMPLET</span><h2 id="history-title">Versions du parcours</h2><p>{project.name}</p></div><button className="icon-button" onClick={onClose} aria-label="Fermer" type="button"><X size={19} /></button></header>
      <section className="history-current"><History size={20} /><span><strong>Version actuelle {project.version}</strong><small>Chaque restauration crée une nouvelle version : rien n’est effacé.</small></span></section>
      <div className="history-version-list">
        {versions.map((version) => {
          const phases = processPhases(version.snapshot, true)
          const steps = phases.reduce((total, phase) => total + phase.steps.length, 0)
          const current = version.version === project.version
          return <article className={current ? 'current' : ''} key={version.id}>
            <div className="history-version-number">v{version.version}</div>
            <div><strong>{version.summary}</strong><span><Clock3 size={13} /> {new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(version.created_at))}</span><small>{phases.length} phases · {steps} étapes · situation au {formatDate(version.snapshot.as_of_date)}</small></div>
            {current ? <span className="history-current-badge">Actuelle</span> : <button disabled={busy} onClick={() => onRestore(version)} title={`Restaurer la version ${version.version} comme nouvelle version`} type="button"><RotateCcw size={15} /> Restaurer <ArrowRight size={14} /></button>}
          </article>
        })}
        {!versions.length ? <div className="history-empty">Aucune version disponible.</div> : null}
      </div>
    </aside>
  </div>
}
